/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { floatEqualAbsolute as t } from "../../core/mathUtils.js";
import { b as n, k as s, u as r, g as e, f as o, m as u, v as c, c as a, l as f } from "../../chunks/vec2.js";
import { b as i, a as p } from "../../chunks/vec2f64.js";

function h(t, n) {
  return t[0] * n[1] - t[1] * n[0];
}

function m(t, s, r) {
  var e = (s[0] - t[0]) * (r[1] - t[1]) - (s[1] - t[1]) * (r[0] - t[0]);
  return Math.abs(e) / n(s, r);
}

function y(t, n, o) {
  var u = s(o, n) / r(o);
  return e(t, o, u);
}

function b(t, n, s, r) {
  var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : s;
  return o(q, r, s), o(U, n, e), y(w, U, q), u(t, e, w);
}

function d(t, n, e, u) {
  o(q, u, e), o(U, n, e);
  var f = s(q, U) / r(q);
  return f > 0 ? c(t, e, q, f) : a(t, e);
}

function l(t, n, s, r) {
  o(q, n, s);
  var e = r / f(q);
  return c(t, s, q, e);
}

function j(n, s) {
  return b(U, s, n.start, n.end), t(U[0], s[0]) && t(U[1], s[1]) ? [i(s)] : [];
}

function k(n, s, r) {
  return l(U, r, n, s), t(U[0], r[0]) && t(U[1], r[1]) ? [i(r)] : [];
}

function v(t, n) {
  var s = t.start,
      r = t.end,
      e = n.start,
      u = n.end,
      a = o(q, r, s),
      f = o(x, u, e),
      i = h(a, f);
  if (Math.abs(i) <= g) return [];
  var p = o(U, s, e),
      m = h(f, p) / i,
      y = h(a, p) / i;

  if (m >= 0) {
    if (y >= 0 || 1 === n.type) return [c(w, s, a, m)];
  } else if (1 === t.type && (y >= 0 || 1 === n.type)) return [c(w, s, a, m)];

  return [];
}

function M(t, n, e) {
  var u = [],
      a = o(q, t.end, t.start),
      f = o(x, t.start, n),
      i = r(a),
      p = 2 * s(a, f),
      h = p * p - 4 * i * (r(f) - e * e);

  if (0 === h) {
    var _n = -p / (2 * i);

    (1 === t.type || _n >= 0) && u.push(c(w, t.start, a, _n));
  } else if (h > 0) {
    var _n2 = Math.sqrt(h),
        _s = (-p + _n2) / (2 * i);

    (1 === t.type || _s >= 0) && u.push(c(w, t.start, a, _s));

    var _r = (-p - _n2) / (2 * i);

    (1 === t.type || _r >= 0) && u.push(c(U, t.start, a, _r));
  }

  return u;
}

var g = 1e-6,
    q = p(),
    x = p(),
    U = p(),
    w = p();
export { h as cross, k as intersectCircleAndPoint, j as intersectLineAndPoint, v as intersectLineAndRay, M as intersectLineLikeAndCircle, m as pointToLineDistance, y as projectPoint, l as projectPointToCircle, b as projectPointToLine, d as projectPointToRay };